import React from 'react';
import styled from 'styled-components';

export default function ChallengeBanner({ imgSrc, challengeInfo }) {
  const challengeStartDate = challengeInfo?.start_date; 
  
  return (
    <ImagesInner>
      <Images>{
        (imgSrc)
        ?(<BannerImg
            key="challenge-cover-img-tag"
            src={imgSrc}
            alt="challenge-banner-item"
        />)
        :(null)
      }</Images>
      {(challengeStartDate === null) && (
        <UnlimitedPeriod>상시모집</UnlimitedPeriod>
      )}
    </ImagesInner>
  );
}

const ImagesInner = styled.div`
  position: relative;
  min-height: calc(100vw * (224 / 375));
`;
const Images = styled.div`
  width: 100%;
`;
const BannerImg = styled.img`
    image-rendering: -moz-crisp-edges;         /* Firefox */
    image-rendering:   -o-crisp-edges;         /* Opera */
    image-rendering: -webkit-optimize-contrast;/* Webkit (non-standard naming) */
    image-rendering: crisp-edges;
    -ms-interpolation-mode: nearest-neighbor;  /* IE (non-standard property) */
`

const UnlimitedPeriod = styled.div`
  position: absolute;
  top: calc(100vw * (9 / 375));
  right: calc(100vw * (10 / 375));
  display: inline-block;
  padding : calc(100vw * (8 / 375)) calc(100vw * (10.5 / 375)); 
  font-style: normal;
  font-weight: bold;
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (16 / 375));  
  color: #ffffff;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 4px;  
  margin-bottom: calc(100vw * (4 / 375));  
`;